import firebase from "../../firebase";

const getGames = async () => {
    let docRefPs5 = await firebase.db.collection("ps5").get();
    let docRefPs4 = await firebase.db.collection("ps4").get();
    let docRefSwitch = await firebase.db.collection("switch").get();
 
    let dataPs4 =  docRefPs4.docs.map(doc =>{
        return {
            id: doc.id,
            ...doc.data()
        }
    })
    let dataPs5 = docRefPs5.docs.map(doc =>{
        return {
            id: doc.id,
            ...doc.data()
        }
    })
    let dataSwitch = docRefSwitch.docs.map(doc =>{
        return {
            id: doc.id,
            ...doc.data()
        }
    });
    
    dataPs4 = dataPs4.concat(dataPs5).concat(dataSwitch);
    
    return dataPs4;
}

export const getGamesByName = async (game) => {
    if(game === ""){
        return [];
    }
    else{
        const games = await getGames();
        const result = games.filter(videogame => videogame.name.toLocaleLowerCase().includes(game));
        return result;
    }
}